import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface ProductCategory {
  category_name: string
  abbreviation: string
}

// ─── Category APIs ────────────────────────────────────────────────────────────

export const getCategories = async (companyId: string): Promise<ProductCategory[] | undefined> => {
  return await axios
    .get(`${API_URL}/product-catalogue/data/${companyId}`)
    .then((response: AxiosResponse<{categories: ProductCategory[]}>) => response.data)
    .then((response) => response.categories)
}

export const createCategory = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/product-catalogue/category`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const editCategory = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.put(`${API_URL}/product-catalogue/category/edit`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteCategory = async (
  companyId: string,
  categoryName: string
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/product-catalogue/category/${companyId}/${categoryName}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}
